module.exports = __webpack_public_path__ + "assets/48633cd2a747418a70f23d13ef01b3ac.mp3";